export const STUDY_PLAN_STATUS = {
  PROPOSED: 'proposed', IN_PROGRESS: 'in_progress', PAUSED: 'paused', FULFILLED: 'fulfilled', UNFULFILLED: 'unfulfilled',
} as const
export type StudyPlanStatus = typeof STUDY_PLAN_STATUS[keyof typeof STUDY_PLAN_STATUS]
export type StudyPlanCloseStatus = typeof STUDY_PLAN_STATUS.FULFILLED | typeof STUDY_PLAN_STATUS.UNFULFILLED
export const STUDY_PLAN_OUTPUT_TYPE = { FREE: 'free', CERTIFICATION: 'certification' } as const
export type StudyPlanOutputType = typeof STUDY_PLAN_OUTPUT_TYPE[keyof typeof STUDY_PLAN_OUTPUT_TYPE]
export interface StudyPlanDeveloper { canManage: boolean; id: string; name: string; teams: { id: string; name: string }[] }
export interface StudyPlanListFilters { developerId?: string; teamId?: string; status?: StudyPlanStatus }
export interface StudyPlanInput {
  developerId: string
  title: string
  objective: string
  expectedOutput: string
  outputType: StudyPlanOutputType
  certificationName: string | null
  startDate: string
  deadline: string | null
  progressPct: number
  learnings: string
  obstacles: string
  comments: string
}
export interface StudyPlan extends StudyPlanInput {
  version: number
  id: string
  status: StudyPlanStatus
  developerName: string
  teams: { id: string; name: string }[]
  canManage: boolean
  canUpdate: boolean
  closedBy: string | null
  closedAt: string | null
  certificationId: string | null
  createdAt: string
  updatedAt: string
}

export type CreateStudyPlanInput = Omit<StudyPlanInput, 'progressPct' | 'learnings' | 'obstacles' | 'comments'>
export type StudyPlanForm = Omit<StudyPlanInput, 'deadline'> & { deadline: string }
